module.exports = __webpack_public_path__ + "img/870.0fc527b5.jpg";